window.matchMedia('(max-width: 990px)').addEventListener('change', setHeaderHeight());

function setHeaderHeight() {
    const headerHeight = document.querySelector('.header-wrapper')
    document.documentElement.style.setProperty('--header-height', `${headerHeight.offsetHeight}px`);
}

setHeaderHeight()


// Define an array of URLs
const urls = [
    "https://www.lvmh.com/en",
    "https://www.doverstreetmarket.com/",
    "https://www.richemont.com/",
    "https://www.kering.com/en/",
    "https://www.britannica.com/biography/Denzel-Washington",
    "https://www.youtube.com/watch?v=Paps_YnkG0Q",
    "https://www.hermes.com/us/en/product/avalon-throw-blanket-H102668Mv52/",
    "https://www.instagram.com/p/C_dXZMhulet/?hl=en&img_index=1",
    "https://www.youtube.com/watch?v=eo9v5DCr6yg",
    "https://cdn.britannica.com/16/77316-050-04120A9B/Denzel-Washington-Training-Day-2001.jpg",
    "https://www.youtube.com/watch?v=hDd2G_V1rzc",
    "https://www.youtube.com/watch?v=TC1pRnmzRQQ",
    "https://culted.com/the-disappearance-of-the-supreme-box-logo-tee/",
    "https://www.mlbshop.com/new-york-yankees/mens-new-york-yankees-x-ac-milan-new-era-black-wordmark-low-profile-9fifty-stretch-snap-hat/t-25333265+p-801167054320173+z-9-3497889384?_ref=p-SRP:m-GRID:i-r13c2:po-41",
    "https://www.youtube.com/watch?v=zK1mLIeXwsQ",
    "https://www.loewe.com/usa/en/women/accessories/hats-and-beanies/loewe-bucket-hat-in-shearling/K820HB1X70-1100.html",
    "https://wristaficionado.com/products/patek-philippe-nautilus-5711-112p-001-platinum-grey-dial-ruby-bezel",
    "https://www.youtube.com/watch?v=WfOiSxLZEfk",
    "https://limosineskateboards.com/",
    "https://www.youtube.com/watch?v=T-64_HO5bJo",
    "https://chess.com",
    "https://www.youtube.com/watch?v=iqS_IbuvFkQ",
    "https://i.pinimg.com/originals/7b/a4/bd/7ba4bdf4610ae460b5cb7b36fa0a0d65.jpg",
    "https://www.youtube.com/watch?v=TRTlvMvS1X8"
  ];
  
  // Function to set a random URL to the href of #HeaderMenu-about-us
  function setRandomHref() {
    // Select the element
    const aboutUsLink = document.querySelector('#HeaderMenu-about-us');
    const aboutUsLinkMobile = document.querySelector('#HeaderDrawer-about-us');
  
    // Check if the element exists
    if (aboutUsLink) {
      // Select a random URL from the array
      const randomUrl = urls[Math.floor(Math.random() * urls.length)];
      
      // Set the href attribute of the selected element
      aboutUsLink.href = randomUrl;
    }

    if (aboutUsLinkMobile) {
        // Select a random URL from the array
        const randomUrl = urls[Math.floor(Math.random() * urls.length)];
  
        // Set the href attribute of the selected element
        aboutUsLinkMobile.href = randomUrl;
    }
  }
  
  // Call the function on page load
  window.onload = setRandomHref;


document.querySelectorAll('#HeaderMenu-about-us, #HeaderDrawer-about-us').forEach(element => {
  element.addEventListener('click', function(event) { 
      // Send the event to Google Analytics
      gtag('event', 'about_link', {
          'event_category': 'Header Menu',
          'event_label': 'About Us Click',
          'value': this.href
      });
  });
});